<template>
  <div class="row ">
    <div class="col-md-12 login-holder">
      <div class="login-box ">
        <img src="../assets/logo.png" alt="Logo" class="img-fluid logo" />
        <form @submit.prevent="login">
          <div class="form-group">
            <input type="email" class="form-control" placeholder="Email" required ref="email" />
          </div>

          <div class="form-group">
            <input :type="showPass ? 'text' : 'password'" class="form-control"  placeholder="Password" ref="password" required minlength="6" />
            <div class="login-icon icon-password">
              <!-- show eye icon -->
              <span  @click="showPass = true" v-if="!showPass"> Show</span>
              <!-- hide eye icon -->
              <span @click="showPass = false" v-else version="1.1">Hide</span>

            </div>
          </div>

          <div class="form-group">
            <button type="submit" class="btn btn-login btn-block">Log In</button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data(){
    return {
      showPass: false
    }
  },
  methods: {
    login(){
      let email = this.$refs.email.value
      let password = this.$refs.password.value
      if(email.length > 0 && password.length > 0){
        this.$axios.post('/login', {email, password})
          .then(res => {
            localStorage.setItem('vt-user-name', res.data.data.name);
            localStorage.setItem('vt-user-email', res.data.data.email);
            localStorage.setItem('vt-token', res.data.data.token);
            this.$router.replace('/');
          })
          .catch(err => {
            swal({
              title: "Login Failed",
              text: err.response.data.message,
              icon: "error"
            })
          })
      }else{
        swal({
          title: "Please enter Email and Password",
          icon: "info"
        })
      }
    }
  }
}
</script>
<style scoped>
  svg{
    opacity: 0.2;
  }
</style>